import { JsonPipe } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, NgModel, Validators } from '@angular/forms';
import { NgbDateStruct, NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { CommonMessageService } from 'src/app/services/common-message.service';
import { MasterDataService } from 'src/app/services/master-data.service';
import { OrganizationSetupService } from 'src/app/services/organization-setup.service';
import Swal from 'sweetalert2';
import { assignment, financialsData, master, misDetails, newClient } from './mis-model';
import { id } from '@swimlane/ngx-charts';
import { HumanResourceService } from 'src/app/services/human-resource.service';



@Component({
  selector: 'app-management-information-system',
  templateUrl: './management-information-system.component.html',
  styleUrls: ['./management-information-system.component.css'],
})
export class ManagementInformationSystemComponent implements OnInit {
  checkList: financialsData[] = [
    {
      id: 1,
      questionNo: 1,
      variable: 'Fees receivable opening balance (closing last quarter)',
      amount: null,
      isRequired: false,
      remark: '',
      particulars: '',
    },
    {
      id: 2,
      questionNo: 2,
      variable: 'Invoices raised during the quarter',
      amount: null,
      isRequired: false,
      remark: '',
      particulars: '',
    },
    {
      id: 3,
      questionNo: 3,
      variable: 'Fees received during the quarter',
      amount: null,
      isRequired: false,
      remark: '',
      particulars: '',
    },
    {
      id: 4,
      questionNo: 4,
      variable: 'Reimbursement received during the quarter',
      amount: null,
      isRequired: false,
      remark: '',
      particulars: '',
    },
    {
      id: 5,
      questionNo: 5,
      variable: 'Fees receivable at the end of quarter',
      amount: null,
      isRequired: false,
      remark: '',
      particulars: '',
    },
    {
      id: 6,
      questionNo: 6,
      variable: 'GST receivable opening balance (closing last quarter)',
      amount: null,
      isRequired: false,
      remark: '',
      particulars: '',
    },
    {
      id: 7,
      questionNo: 7,
      variable: 'GST on Invoices raised during the quarter',
      amount: null,
      isRequired: false,
      remark: '',
      particulars: '',
    },
    {
      id: 8,
      questionNo: 8,
      variable: 'GST received during the quarter',
      amount: null,
      isRequired: false,
      remark: '',
      particulars: '',
    },
    {
      id: 9,
      questionNo: 9,
      variable: 'GST receivable at the end of quarter',
      amount: null,
      isRequired: false,
      remark: '',
      particulars: '',
    },
    {
      id: 10,
      questionNo: 10,
      variable: 'Employees cost',
      amount: null,
      isRequired: false,
      remark: '',
      particulars: '',
    },
    {
      id: 11,
      questionNo: 11,
      variable: 'Consultants cost',
      amount: null,
      isRequired: false,
      remark: '',
      particulars: '',
    },
    {
      id: 12,
      questionNo: 12,
      variable: 'Articles cost',
      amount: null,
      isRequired: false,
      remark: '',
      particulars: '',
    },
    {
      id: 16,
      questionNo: 16,
      variable: 'Fixed partners salary',
      amount: null,
      isRequired: false,
      remark: '',
      particulars: '',
    },
    {
      id: 13,
      questionNo: 13,
      variable: 'Invoices written off',
      amount: null,
      isRequired: false,
      remark: '',
      particulars: '',
    },
    {
      id: 14,
      questionNo: 14,
      variable: 'Credit notes issued',
      amount: null,
      isRequired: false,
      remark: '',
      particulars: '',
    },
    {
      id: 15,
      questionNo: 15,
      variable: 'Invoices > 6 months',
      amount: null,
      isRequired: false,
      remark: '',
      particulars: '',
    },
  ];

  mis: master = new master();
  files: any[] = [];
  isUpdate = true;
  selectedQuarter = '';
  formData: FormData;
  isAssignmentSelected = false;

  FrequencyList = [
    { id: 1, name: 'Monthly' },
    { id: 2, name: 'Quarterly' },
    { id: 3, name: 'Anually' },
    { id: 4, name: 'One Time' },
  ];

  QuarterList = [
    { id: 1, name: 'Quarter1' },
    { id: 2, name: 'Quarter2' },
    { id: 3, name: 'Quarter3' },
    { id: 4, name: 'Quarter4' },
  ];

  dateJoined: any = '2023-01-25T06:30:00.590+00:00';

  incentiveToList;

  engagementPerformanceList = [
    {
      question:
        'Confirm that there were no challenges regarding resources with right and appropriate skill set for carrying out any assignmnets this quarter as per PGB policies',
      answer: '',
      remark: '',
      id: 1,
      dropdownList: [
        { id: 1, value: 'I confirm' },
        { id: 2, value: 'There were challenges' },
      ],
      expectedValue: 'There were challenges',
      required: false,
    },
    {
      question:
        'Confirm that appropriate assignment level trainings were conducted during the quarter',
      answer: '',
      remark: '',
      id: 2,
      dropdownList: [
        { id: 1, value: 'I confirm' },
        { id: 2, value: 'None were conducted' },
        { id: 3, value: 'Not applicable' },
      ],
      expectedValue: 'None were conducted',
      required: false,
    },
    {
      question:
        'Confirm that appointment formalities like appointment letter, engagements letters, acceptance and independence have been completed for the assignments that have been started during this quarter',
      answer: '',
      remark: '',
      id: 3,
      dropdownList: [
        { id: 1, value: 'Yes' },
        { id: 2, value: 'No' },
        { id: 3, value: 'No new appointments' },
      ],
      expectedValue: 'No',
      required: false,
    },
    {
      question:
        'Cofirm that you have obtained consultation for issues as decided by QMRD for assignments completed during the quarter',
      answer: '',
      remark: '',
      id: 4,
      dropdownList: [
        { id: 1, value: 'Yes' },
        { id: 2, value: 'No issues warrating consultation' },
      ],
      expectedValue: null,
      required: false,
    },
    {
      question:
        'For assignments requiring quality review pre issuance confirm that the same was cleared by QRP',
      answer: '',
      remark: '',
      id: 5,
      dropdownList: [
        { id: 1, value: 'Yes' },
        { id: 2, value: 'None' },
      ],
      expectedValue: '',
      required: false,
    },
    {
      question:
        'Are there any disputes, issues with the client that you have to discuss ?',
      answer: '',
      remark: '',
      id: 6,
      dropdownList: [
        { id: 1, value: 'Yes' },
        { id: 2, value: 'None' },
      ],
      expectedValue: 'Yes',
      required: false,
    },
    {
      question:
        'Have you ensured that UDIN is generated for all the deliverables during the quarter ?',
      answer: '',
      remark: '',
      id: 7,
      dropdownList: [
        { id: 1, value: 'Yes' },
        { id: 2, value: 'Few are pending' },
      ],
      expectedValue: 'Few are pending',
      required: false,
    },
    {
      question:
        'Confirm that invoices have been raised against all the UDINs generated during the quarter',
      answer: '',
      remark: '',
      id: 8,
      dropdownList: [
        { id: 1, value: 'Yes' },
        { id: 2, value: 'Few are pending' },
      ],
      expectedValue: 'Few are pending',
      required: false,
    },
  ];

  independenceList = [
    {
      question:
        'Confirm that you have not accepted an audit of a client to whom you or your family members/relatives are indebted to or have given guarantee to or have given security to in this quarter?',
      answer: '',
      remark: '',
      id: 1,
      dropdownList: [
        { id: 1, value: 'I confirm' },
        { id: 2, value: 'There is exposure' },
      ],
      expectedValue: '',
      required: false,
    },
    {
      question:
        'Confirm that you have not provided any service which is prohited under the Companies Act, 2013 specified under section 144 in this quarter to any client',
      answer: '',
      remark: ' ',
      id: 2,
      dropdownList: [
        { id: 1, value: 'I confirm' },
        { id: 2, value: 'I have taken consultation' },
      ],
      expectedValue: '',
      required: false,
    },
    {
      question: 'Have you have withdrawn from any assignment in this quarter?',
      answer: '',
      remark: '',
      id: 3,
      dropdownList: [
        { id: 1, value: 'Yes' },
        { id: 2, value: 'No' },
      ],
      expectedValue: 'Yes',
      required: false,
    },
    {
      question:
        'Have you come across any independence issue or conflict on interest issue within  your engagement team in this quarter',
      answer: '',
      remark: '',
      id: 4,
      dropdownList: [
        { id: 1, value: 'Yes' },
        { id: 2, value: 'No' },
      ],
      expectedValue: 'Yes',
      required: false,
    },
    {
      question:
        'Indentify clients from whom more 15% of the total receipts of the firm are received ?',
      answer: '',
      remark: '',
      id: 5,
      dropdownList: [
        { id: 1, value: 'Yes' },
        { id: 2, value: 'None' },
      ],
      expectedValue: 'Yes',
      required: false,
    },
    {
      question:
        'Have you implemented any guidance received from the Independence Partner this quarter and have you replied to his email ? Specify date',
      answer: '',
      remark: '',
      id: 6,
      dropdownList: [
        { id: 1, value: 'Yes' },
        { id: 2, value: 'None' },
      ],
      expectedValue: 'Yes',
      required: false,
    },
    {
      question:
        "Confirm that you have ensured that no rotation was applicable to any audit client as per the firm's partner rotation policy this quarter ?",
      answer: '',
      remark: '',
      id: 7,
      dropdownList: [
        { id: 1, value: 'I confirm' },
        { id: 2, value: 'I have rotated' },
      ],
      expectedValue: '',
      required: false,
    },
    {
      question:
        'Confirm that no gift from any client of any significant value was accepted by yourself and enagement team',
      answer: '',
      remark: '',
      id: 8,
      dropdownList: [
        { id: 1, value: 'I confirm' },
        { id: 2, value: 'I have taken consultation' },
      ],
      expectedValue: '',
      required: false,
    },
    {
      question:
        'Confirm that you do not have any financial interests directly or indirectly in an audit client.',
      answer: '',
      remark: '',
      id: 9,
      dropdownList: [
        { id: 1, value: 'I confirm' },
        { id: 2, value: 'I have taken consultation' },
      ],
      expectedValue: '',
      required: false,
    },
    {
      question:
        'Confirm whether any employee of your engagement team has joined our audit client in this quarter',
      answer: '',
      remark: '',
      id: 10,
      dropdownList: [
        { id: 1, value: 'Yes' },
        { id: 2, value: 'No' },
      ],
      expectedValue: 'Yes',
      required: false,
    },
  ];

  uploadedDocs = [
    { name: 'test.pdf', size: 2.3 },
    { name: 'test.pdf', size: 2.3 },
    { name: 'test.pdf', size: 2.3 },
  ];

  newClientSelectValue = '';
  newAssignExistingClient = '';
  clientAssignDiscontinued = '';
  feesIncreasedDecreased = '';
  potentialClientAssign = '';
  materialIssuesSection = '';

  workflow: FormGroup;
  assignmentList;
  userId;
  Currentyear;
  financialList;
  PrevYear;
  fyYear;
  fyId = null;
  clientList;
  discontinuedClientList;
  selectedDate: NgbDateStruct;
 

  ngOnInit(): void {
    this.userId = localStorage.getItem('id');
   
    this.PrevYear = new Date().getFullYear() - 1;
    this.Currentyear = new Date().getFullYear();
    this.fyYear = this.PrevYear + '-' + this.Currentyear;
    console.log('selected quarter', this.selectedQuarter);

    this.masterDataService.getFinancialYear().subscribe((res) => {
      this.financialList = res;
      console.log('financial Year:', this.financialList);
    });

    console.log('outside current fy id:', this.fyId);

    //this.calculateCurrentYearAndUser();
    //this.getMisDetails();
    this.loadAssignments();

    //this.getAllClientDetails();
  }

  parseDate(dateString: string): NgbDateStruct {
    var demoDate: Date;
    if (dateString == null) {
      const year = null;
      const month = null;
      const day = null;
      return { year, month, day };
    }
    if (dateString === '') {
      return null;
    } else {
      const date = new Date(dateString);
      const year = date.getUTCFullYear();
      const month = date.getUTCMonth() + 1;
      const day = date.getUTCDate();
      return { year, month, day };
    }
  }

  selectAllAssignment(select: NgModel, values) {
    this.selectAll(select, values, this.isAssignmentSelected);
    this.isAssignmentSelected = !this.isAssignmentSelected;
  }

  selectAll(select: NgModel, values, isSelected) {
    if (!isSelected) {
      select.update.emit(values);
    } else select.update.emit([]);
  }

  formatDate(date: NgbDateStruct): string {
    console.log('type of date :', typeof date);

    if (date == null) {
      return null;
    }
    if (typeof date == 'string') {
      return date;
    } else {
      if (date.day != null && date.month != null && date.year != null) {
        console.log('format date', date);
        const year = date.year.toString().padStart(4, '0');
        const month = date.month.toString().padStart(2, '0');
        const day = date.day.toString().padStart(2, '0');
        return `${year}-${month}-${day}T00:00:00.000+00:00`;
      }
    }
  }

  initAssignments(i: number, response: any) {
    this.mis.misDetails.business.newClient[i].branch = response.branch;
    console.log('initAssign: creation date' + response.creationDate);
    this.mis.misDetails.business.newClient[i].clientCreationDate =
      this.parseDate(response.creationDate);

    for (let index = 0; index < response.assignmentFees.length; index++) {
      this.mis.misDetails.business.newClient[i].assignments.push({
        assignmentId: response.assignmentFees[index].assignmentId,
        id: null,
        frequency: '',
        fees: response.assignmentFees[index].fees,
        incentiveTo: null,
        budgetedContributionPercentage: null,
        appointmentDate: null,
        dateOfNocSent: null,
        engagementLetterDate: null,
        required: false,
        NOCrequired: '',
        ELrequired: '',
      });

      if (
        this.mis.misDetails.business.newClient[i].assignments[index]
          .dateOfNocSent
      ) {
        this.mis.misDetails.business.newClient[i].assignments[
          index
        ].NOCrequired = 'yes';
      } else {
        this.mis.misDetails.business.newClient[i].assignments[
          index
        ].NOCrequired = '';
      }
      if (
        this.mis.misDetails.business.newClient[i].assignments[index]
          .engagementLetterDate
      ) {
        this.mis.misDetails.business.newClient[i].assignments[
          index
        ].ELrequired = 'yes';
      } else {
        this.mis.misDetails.business.newClient[i].assignments[
          index
        ].NOCrequired = '';
      }
    }
    console.log('test', this.mis.misDetails.business.newClient[i]);
  }

  initMis(response: any) {
    let resp: master = new master();
    this.mis = new master();

    if (response.misDetails == null) {
      this.isUpdate = false;
      this.mis.fyId = this.fyId;
      this.mis.quarter = this.selectedQuarter;
      resp = JSON.parse(JSON.stringify(this.mis));
      this.hideSectionInitially();
    } else {
      console.log('initialy recieved response:', response);
      this.isUpdate = true;
      resp = JSON.parse(JSON.stringify(response));
      console.log('resp', resp);
    }

    resp.misDetails.financialsData = JSON.parse(JSON.stringify(this.checkList));
    resp.misDetails.engagementPerformance = JSON.parse(
      JSON.stringify(this.engagementPerformanceList)
    );
    resp.misDetails.independence = JSON.parse(
      JSON.stringify(this.independenceList)
    );
    if (resp.misDetails == null) {
      //resp.misDetails.engagementPerformance=JSON.stringify(this.engagementPerformanceList)
    }

    console.log('responseJSON', resp);

    if (response.misDetails == null) {
      console.log('empty');
    } else {
      console.log('not empty');
      console.log('resp list', resp);
      for (let i = 0; i < resp.misDetails.financialsData.length; i++) {
        for (let j = 0; j < response.misDetails.financialsData.length; j++) {
          if (
            resp.misDetails.financialsData[i].variable ==
            response.misDetails.financialsData[j].variable
          ) {
            resp.misDetails.financialsData[i].amount =
              response.misDetails.financialsData[j].amount;
            resp.misDetails.financialsData[i].remark =
              response.misDetails.financialsData[j].remark;
            resp.misDetails.financialsData[i].id =
              response.misDetails.financialsData[j].id;
          }
        }
      }

      if (response.misDetails.engagementPerformance.length > 0) {
        for (let i = 0; i < resp.misDetails.engagementPerformance.length; i++) {
          for (
            let j = 0;
            j < response.misDetails.engagementPerformance.length;
            j++
          ) {
            if (
              resp.misDetails.engagementPerformance[i].question ==
              response.misDetails.engagementPerformance[j].question
            ) {
              resp.misDetails.engagementPerformance[i].answer =
                response.misDetails.engagementPerformance[j].answer;
              resp.misDetails.engagementPerformance[i].remark =
                response.misDetails.engagementPerformance[j].remark;
              resp.misDetails.engagementPerformance[i].id =
                response.misDetails.engagementPerformance[j].id;
            }
          }
        }
      }

      if (response.misDetails.independence.length > 0) {
        for (let i = 0; i < resp.misDetails.independence.length; i++) {
          for (let j = 0; j < response.misDetails.independence.length; j++) {
            if (
              resp.misDetails.independence[i].question ==
              response.misDetails.independence[j].question
            ) {
              resp.misDetails.independence[i].answer =
                response.misDetails.independence[j].answer;
              resp.misDetails.independence[i].remark =
                response.misDetails.independence[j].remark;
              resp.misDetails.independence[i].id =
                response.misDetails.independence[j].id;
            }
          }
        }
      }

      for (let i = 0; i < resp.misDetails.business.newClient.length; i++) {
        resp.misDetails.business.newClient[i].clientCreationDate =
          this.parseDate(
            resp.misDetails.business.newClient[i].clientCreationDate
          );
        for (
          let j = 0;
          j < resp.misDetails.business.newClient[i].assignments.length;
          j++
        ) {
          resp.misDetails.business.newClient[i].assignments[j].appointmentDate =
            this.parseDate(
              resp.misDetails.business.newClient[i].assignments[j]
                .appointmentDate
            );

          resp.misDetails.business.newClient[i].assignments[j].dateOfNocSent =
            this.parseDate(
              resp.misDetails.business.newClient[i].assignments[j].dateOfNocSent
            );
          resp.misDetails.business.newClient[i].assignments[
            j
          ].engagementLetterDate = this.parseDate(
            resp.misDetails.business.newClient[i].assignments[j]
              .engagementLetterDate
          );
        }
      }

      for (let i = 0; i < resp.misDetails.business.newClient.length; i++) {
        for (let j = 0;j < resp.misDetails.business.newClient[i].assignments.length;j++) 
        {
          if (resp.misDetails.business.newClient[i].assignments[j].dateOfNocSent) 
          {
            if (resp.misDetails.business.newClient[i].assignments[j].dateOfNocSent.year) 
            {
              resp.misDetails.business.newClient[i].assignments[j].NOCrequired = 'yes';
            }
            else{
              resp.misDetails.business.newClient[i].assignments[j].NOCrequired = 'no';
            }

          } else {
            resp.misDetails.business.newClient[i].assignments[j].NOCrequired = 'no';
          }

          if (resp.misDetails.business.newClient[i].assignments[j].engagementLetterDate) 
          {
              if (resp.misDetails.business.newClient[i].assignments[j].engagementLetterDate.year) 
            {
              resp.misDetails.business.newClient[i].assignments[j].ELrequired ='yes';
            }
            else {
              resp.misDetails.business.newClient[i].assignments[j].ELrequired ='no';
            }

          } else {
            resp.misDetails.business.newClient[i].assignments[j].ELrequired ='no';
          }
          if (
            resp.misDetails.business.newClient[i].assignments[j].incentiveTo) {

          } else {
             resp.misDetails.business.newClient[i].assignments[j].incentiveTo = null;
          }
        }
      }
    }

    for (let i = 0; i < resp.misDetails.financialInterests.loan.length; i++) {
      resp.misDetails.financialInterests.loan[i].maturityDate = this.parseDate(
        resp.misDetails.financialInterests.loan[i].maturityDate
      );
    }

    if(resp.misDetails.training.actualTraining.cpe==0 && resp.misDetails.training.actualTraining.pgbInternal==0 && resp.misDetails.training.actualTraining.pgbPresenter==0)
    {
      resp.misDetails.training.balanceTraining.pgbPresenter=6;
      resp.misDetails.training.balanceTraining.pgbInternal=9;
      resp.misDetails.training.balanceTraining.cpe=30;

    }

    this.mis = resp;
    console.log('mis: ', this.mis);

    if (response.misDetails != null) {
      this.showSectionIfFormFilled(resp);
      this.detectRequiredValidationOfList(
        this.mis.misDetails.engagementPerformance
      );
      this.detectRequiredValidationOfList(this.mis.misDetails.independence);
    } else {
      this.newClientSelectValue = '';
      this.newAssignExistingClient = '';
      this.clientAssignDiscontinued = '';
      this.feesIncreasedDecreased = '';
      this.potentialClientAssign = '';
      this.materialIssuesSection = '';
    }

    switch (this.selectedQuarter) {
      case 'Quarter2':
        this.organizationSetupService
          .getMisDetails(this.fyId, 'Quarter1')
          .subscribe((quarterOneResponse: any) => {
            console.log('quarterOneResponse', quarterOneResponse);
            console.log('fy id:', this.fyId);

            if (
              quarterOneResponse != null &&
              quarterOneResponse.status === 'Submitted'
            ) {
              this.updateMisDetailsForCalculation(quarterOneResponse, this.mis);
            }
          });
        break;

      case 'Quarter3':
        this.organizationSetupService
          .getMisDetails(this.fyId, 'Quarter2')
          .subscribe((quarterOneResponse: any) => {
            console.log('quarterOneResponse', quarterOneResponse);
            console.log('fy id:', this.fyId);

            if (
              quarterOneResponse != null &&
              quarterOneResponse.status === 'Submitted'
            ) {
              this.updateMisDetailsForCalculation(quarterOneResponse, this.mis);
            }
          });
        break;

      case 'Quarter4':
        this.organizationSetupService
          .getMisDetails(this.fyId, 'Quarter3')
          .subscribe((quarterOneResponse: any) => {
            console.log('quarterOneResponse', quarterOneResponse);
            console.log('fy id:', this.fyId);

            if (
              quarterOneResponse != null &&
              quarterOneResponse.status === 'Submitted'
            ) {
              this.updateMisDetailsForCalculation(quarterOneResponse, this.mis);
            }
          });
        break;

      default:
        break;
    }
  }

  constructor(
    private modalService: NgbModal,
    private fb: FormBuilder,
    private humanResourceService: HumanResourceService,
    private masterDataService: MasterDataService,
    private organizationSetupService: OrganizationSetupService,
    private commonMessageService: CommonMessageService
  ) {}

  public updateMisDetailsForCalculation(quarterOneResponse: any, mis: any) {
    const quarterOneFinancialsData =
      quarterOneResponse.misDetails.financialsData;
    const misFinancialsData = mis.misDetails.financialsData;

    const feesReceivableIndex = quarterOneFinancialsData.findIndex(
      (data: any) => data.variable === 'Fees receivable at the end of quarter'
    );
    if (feesReceivableIndex !== -1) {
      const openingBalanceIndex = misFinancialsData.findIndex(
        (data: any) =>
          data.variable ===
          'Fees receivable opening balance (closing last quarter)'
      );
      if (openingBalanceIndex !== -1) {
        misFinancialsData[openingBalanceIndex].amount =
          quarterOneFinancialsData[feesReceivableIndex].amount;
      }
    }

    const feesReceivableGstIndex = quarterOneFinancialsData.findIndex(
      (data: any) => data.variable === 'GST receivable at the end of quarter'
    );
    if (feesReceivableGstIndex !== -1) {
      const openingBalanceGSTIndex = misFinancialsData.findIndex(
        (data: any) =>
          data.variable ===
          'GST receivable opening balance (closing last quarter)'
      );
      if (openingBalanceGSTIndex !== -1) {
        misFinancialsData[openingBalanceGSTIndex].amount =
          quarterOneFinancialsData[feesReceivableGstIndex].amount;
      }
    }

    console.log('after changing quarter2', mis);
  }

  public calculateCurrentYearAndUser() {
    // const current = new Date();
    //     this.currentDate = {
    //     year: current.getFullYear(),};
  }

  loadAssignments() {
    this.masterDataService.getAssignments().subscribe((res) => {
      console.log('assignmentList:', res);
      this.assignmentList = res;
    });
  }

  stringJson;
  getAllClientDetails() {
    this.masterDataService
      .getAllClientByYear(this.fyId, this.userId)
      .subscribe((resp: any) => {
        console.log('client list', resp);
        this.clientList = resp;
      });
  }

  getAllClientForDiscountinuedList() {
    this.masterDataService
      .getAllClientByPartner(this.userId)
      .subscribe((resp: any) => {
        console.log('discontinued client list', resp);
        this.discontinuedClientList = resp;
      });
  }

  onFinancialYearSelect() {
    if (this.selectedQuarter) {
      this.getMisDetails();
    }
  }

  onDeleteDocument(index: number) {
    Swal.fire({
      text: 'Are you sure you want to remove?',
      showCancelButton: true,
      confirmButtonText: 'Ok',
      confirmButtonColor: '#800000',
    }).then((result) => {
      if (result.isConfirmed) {
        // this.masterDataService.deleteDocument(document.id).subscribe((resp: any) => {
        this.mis.misDetails.financialInterests.documents.splice(index, 1);
        this.commonMessageService.deleteMessage();
        // this.mainFolderDocuments(this.folderList.id);
        // });
      }
    });
  }

  getMisDetails() {
    // this.deleteFile(0);
    console.log('fy id:', this.fyId);
    console.log('selected quarter', this.selectedQuarter);
    if (this.selectedQuarter) {
      if (this.fyId) {
        this.masterDataService
          .getAllClientByYearAndBudget(this.fyId)
          .subscribe((resp: any) => {
            console.log('client list', resp);
            this.clientList = resp;
          });

          this.masterDataService
      .getAllClientByPartner(this.userId)
      .subscribe((resp: any) => {
        console.log('discontinued client list', resp);
        this.discontinuedClientList = resp;
      });

        this.humanResourceService
          .getEmployeeProfile(1)
          .subscribe((res: any) => {
            this.incentiveToList = res;
            console.log('incentiveToList:', this.incentiveToList);
          });

        this.organizationSetupService
          .getMisDetails(this.fyId, this.selectedQuarter)
          .subscribe((response: any) => {
            console.log('mis', response);
            console.log('fy id:', this.fyId);
            this.initMis(response);

            // if(response)
            // {
            //     if()
            // }
          });
      } else {
        this.commonMessageService.swalAlertWithIcon(
          '',
          'Select Financial Year!',
          'info'
        );
      }
    }
  }

  getAssignmentFieldsForClient(index: number) {
    if (this.mis.misDetails.business.newClient[index].assignments) {
      this.mis.misDetails.business.newClient[index].assignments.splice(0);
      console.log('getAssignmentFieldsForClient');
      console.log('fy id:', this.fyId);
      console.log(
        'client id',
        this.mis.misDetails.business.newClient[index].clientId
      );
    }
    if (this.selectedQuarter) {
      if (this.fyId && this.mis.misDetails.business.newClient[index].clientId) {
        this.organizationSetupService
          .getAssignmentFeesForClientForFy(
            this.fyId,
            this.mis.misDetails.business.newClient[index].clientId
            // this.userId
          )
          .subscribe((response: any) => {
            console.log('mis', response);
            //this.initMis(response);
            this.initAssignments(index, response);
          });
      } else {
        this.commonMessageService.swalAlertWithIcon(
          '',
          'Select Client!',
          'info'
        );
      }
    }
  }

  onDropdownChange(selectedValue: string, divId: string) {
    console.log('on dropdown change');
    if (selectedValue === 'no' || selectedValue === '') {
      document.getElementById(divId).style.display = 'none';

      if (
        divId === 'newClientsDiv' &&
        this.mis.misDetails.business.newClient.length
      ) {
        for (
          let i = 0;
          i < this.mis.misDetails.business.newClient.length;
          i++
        ) {
          this.removeNewClientSection(i);
        }
      }
      if (
        divId === 'newAssignExistClientsDiv' &&
        this.mis.misDetails.business.newAssignmentForExistingClient.length
      ) {
        for (
          let i = 0;
          i <
          this.mis.misDetails.business.newAssignmentForExistingClient.length;
          i++
        ) {
          this.removeNewAssignmentWithExistClient(i);
        }
      }
      if (
        divId === 'ClientAssignDiscontinuedDiv' &&
        this.mis.misDetails.business.clientsOrAssignmentDiscontinued.length
      ) {
        for (
          let i = 0;
          i <
          this.mis.misDetails.business.clientsOrAssignmentDiscontinued.length;
          i++
        ) {
          this.removeClientAssignmentDiscontinued(i);
        }
      }
      if (
        divId === 'feesIncreasedDecreasedDiv' &&
        this.mis.misDetails.business.feesIncreasedOrDecreased.length
      ) {
        for (
          let i = 0;
          i < this.mis.misDetails.business.feesIncreasedOrDecreased.length;
          i++
        ) {
          this.removeFeesIncreasedOrDecreased(i);
        }
      }
      if (
        divId === 'materialIssuesDiv' &&
        this.mis.misDetails.materialIssues.length
      ) {
        for (let i = 0; i < this.mis.misDetails.materialIssues.length; i++) {
          this.removeMaterialIssues(i);
        }
      }
      if (
        divId === 'potentialClientDiv' &&
        this.mis.misDetails.business.potentialClientOrAssignment.length
      ) {
        for (
          let i = 0;
          i < this.mis.misDetails.business.potentialClientOrAssignment.length;
          i++
        ) {
          this.removePotentialClientOrAssignment(i);
        }
      }
    } else if (selectedValue === 'yes') {
      document.getElementById(divId).style.display = 'block';

      if (
        divId === 'newClientsDiv' &&
        !this.mis.misDetails.business.newClient.length
      ) {
        this.addNewClientSection();
      }
      if (
        divId === 'newAssignExistClientsDiv' &&
        !this.mis.misDetails.business.newAssignmentForExistingClient.length
      ) {
        this.addNewAssignmentWithExistClient();
      }
      if (
        divId === 'ClientAssignDiscontinuedDiv' &&
        !this.mis.misDetails.business.clientsOrAssignmentDiscontinued.length
      ) {
        this.addClientAssignmentDiscontinued();
      }
      if (
        divId === 'feesIncreasedDecreasedDiv' &&
        !this.mis.misDetails.business.feesIncreasedOrDecreased.length
      ) {
        this.addFeesIncreasedOrDecreased();
      }
      if (
        divId === 'potentialClientDiv' &&
        !this.mis.misDetails.business.potentialClientOrAssignment.length
      ) {
        this.addPotentialClientOrAssignment();
      }
      if (
        divId === 'materialIssuesDiv' &&
        !this.mis.misDetails.materialIssues.length
      ) {
        this.addMaterialIssues();
      }
    }
  }

  hideSectionInitially() {
    document.getElementById('newClientsDiv').style.display = 'none';
    document.getElementById('newAssignExistClientsDiv').style.display = 'none';
    document.getElementById('ClientAssignDiscontinuedDiv').style.display =
      'none';
    document.getElementById('feesIncreasedDecreasedDiv').style.display = 'none';
    document.getElementById('potentialClientDiv').style.display = 'none';
    document.getElementById('materialIssuesDiv').style.display = 'none';
  }

  showSectionIfFormFilled(resp: any) {
    if (resp.misDetails.business.newClient && this.checkNewClientSection()) {
      this.onDropdownChange('yes', 'newClientsDiv');
      console.log('show select yes:');
      this.newClientSelectValue = 'yes';
    } else {
      if (this.isUpdate) {
        this.onDropdownChange('no', 'newClientsDiv');
        this.newClientSelectValue = 'no';
      } else {
        this.newClientSelectValue = '';
        console.log('show select No:');
      }
    }
    if (
      resp.misDetails.business.newAssignmentForExistingClient &&
      this.checkNewAssignExistingClient()
    ) {
      this.onDropdownChange('yes', 'newAssignExistClientsDiv');
      this.newAssignExistingClient = 'yes';
      console.log('newAssignExistClientsDiv yes');
    } else {
      if (this.isUpdate) {
        this.onDropdownChange('no', 'newAssignExistClientsDiv');
        this.newAssignExistingClient = 'no';
      } else {
        this.newAssignExistingClient = '';
        console.log('newAssignExistClientsDiv no');
      }
    }
    if (
      resp.misDetails.business.clientsOrAssignmentDiscontinued &&
      this.checkClientAssignDiscontinued()
    ) {
      this.onDropdownChange('yes', 'ClientAssignDiscontinuedDiv');
      this.clientAssignDiscontinued = 'yes';
    } else {
      if (this.isUpdate) {
        this.onDropdownChange('no', 'ClientAssignDiscontinuedDiv');
        this.clientAssignDiscontinued = 'no';
      } else {
        this.clientAssignDiscontinued = '';
        console.log('ClientAssignDiscontinuedDiv no');
      }
    }
    if (
      resp.misDetails.business.feesIncreasedOrDecreased &&
      this.checkFeesIncreasedDecreased()
    ) {
      this.onDropdownChange('yes', 'feesIncreasedDecreasedDiv');
      this.feesIncreasedDecreased = 'yes';
    } else {
      if (this.isUpdate) {
        this.onDropdownChange('no', 'feesIncreasedDecreasedDiv');
        this.feesIncreasedDecreased = 'no';
      } else {
        this.feesIncreasedDecreased = '';
        console.log('feesIncreasedDecreased no');
      }
    }
    if (
      resp.misDetails.business.potentialClientOrAssignment &&
      this.checkPotentialClientAssign()
    ) {
      this.onDropdownChange('yes', 'potentialClientDiv');
      this.potentialClientAssign = 'yes';
    } else {
      this.potentialClientAssign = '';
      if (this.isUpdate) {
        this.onDropdownChange('no', 'potentialClientDiv');
        this.potentialClientAssign = 'no';
      } else {
        this.potentialClientAssign = '';
        console.log('potentialClientDiv no');
      }
    }
    if (resp.misDetails.materialIssues && this.checkMaterialIssues()) {
      this.onDropdownChange('yes', 'materialIssuesDiv');
      this.materialIssuesSection = 'yes';
    } else {
      this.materialIssuesSection = '';
      console.log('material issue empty');
      if (this.isUpdate) {
        this.onDropdownChange('no', 'materialIssuesDiv');
        this.materialIssuesSection = 'no';
      } else {
        this.materialIssuesSection = '';
        console.log('materialIssuesSection no');
      }
    }
  }

  getEngagementTeamRole(): FormArray {
    return this.workflow.get('engagementTeamRole') as FormArray;
  }

  addNewClientSection() {
    this.mis.misDetails.business.newClient.push({
      clientId: null,
      assignments: [],
      branch: null,
      clientCreationDate: '',
      required: true,
    });

    console.log(this.mis.misDetails.business.newClient);
  }

  addNewClientAssignmentsSection(index: number) {
    this.mis.misDetails.business.newClient[index].assignments.push({
      assignmentId: null,
      id: null,
      frequency: '',
      fees: null,
      incentiveTo: null,
      budgetedContributionPercentage: null,
      appointmentDate: null,
      dateOfNocSent: null,
      engagementLetterDate: null,
      required: false,
      NOCrequired: '',
      ELrequired: '',
    });

    console.log('index no:', index);
  }

  addNewAssignmentWithExistClient() {
    this.mis.misDetails.business.newAssignmentForExistingClient.push({
      clientId: null,
      assignmentId: null,
      frequency: '',
      fees: null,
      budgetedContributionPercentage: null,
    });

    console.log(this.mis.misDetails.business.newAssignmentForExistingClient);
  }

  addLoanSection() {
    this.mis.misDetails.financialInterests.loan.push({
      bank: null,
      loanPurpose: null,
      loanAmount: null,
      maturityDate: null,
    });

    console.log(this.mis.misDetails.financialInterests.loan);
  }

  addPrivateInvestment() {
    this.mis.misDetails.financialInterests.privateInvestment.push({
      companyName: null,
      investmentNature: null,
      sharesCount: null,
      amount: null,
    });

    console.log(this.mis.misDetails.financialInterests.privateInvestment);
  }

  addClientAssignmentDiscontinued() {
    this.mis.misDetails.business.clientsOrAssignmentDiscontinued.push({
      clientId: null,
      assignmentId: null,
      reason: null,
      fees: null,
    });

    console.log(this.mis.misDetails.business.clientsOrAssignmentDiscontinued);
  }

  addFeesIncreasedOrDecreased() {
    this.mis.misDetails.business.feesIncreasedOrDecreased.push({
      clientId: null,
      assignmentId: null,
      remark: null,
      oldFees: null,
      newFees: null,
    });
    console.log(this.mis.misDetails.business.feesIncreasedOrDecreased);
  }

  addMaterialIssues() {
    this.mis.misDetails.materialIssues.push({
      client: null,
      description: '',
      answer: 'yes',
      required: true,
    });
    console.log(this.mis.misDetails.materialIssues);
  }

  addPotentialClientOrAssignment() {
    this.mis.misDetails.business.potentialClientOrAssignment.push({
      clientName: '',
      assignmentId: null,
      frequency: '',
      fees: null,
      connectName: '',
      email1: '',
      email2: '',
    });

    console.log(this.mis.misDetails.business.potentialClientOrAssignment);
  }

  removeNewAssignmentWithExistClient(index: number) {
    this.mis.misDetails.business.newAssignmentForExistingClient.splice(
      index,
      1
    );
  }

  removeLoanSection(index: number) {
    this.mis.misDetails.financialInterests.loan.splice(index, 1);
  }

  removeMaterialIssues(index: number) {
    this.mis.misDetails.materialIssues.splice(index, 1);
  }

  removePrivateInvestment(index: number) {
    this.mis.misDetails.financialInterests.privateInvestment.splice(index, 1);
  }

  removeNewClientSection(index: number) {
    this.mis.misDetails.business.newClient.splice(index, 1);
  }

  removeNewClientAssignmentsSection(index1: number, index2: number) {
    this.mis.misDetails.business.newClient[index1].assignments.splice(
      index2,
      1
    );
  }

  removeFeesIncreasedOrDecreased(index: number) {
    this.mis.misDetails.business.feesIncreasedOrDecreased.splice(index, 1);
  }

  removeClientAssignmentDiscontinued(index: number) {
    this.mis.misDetails.business.clientsOrAssignmentDiscontinued.splice(
      index,
      1
    );
  }

  removePotentialClientOrAssignment(index: number) {
    this.mis.misDetails.business.potentialClientOrAssignment.splice(index, 1);
  }

  calculateTrainingSection() {
    if (
      this.mis.misDetails.training.requiredTraining.pgbPresenter != null &&
      this.mis.misDetails.training.actualTraining.pgbPresenter != null
    ) {
      this.mis.misDetails.training.balanceTraining.pgbPresenter =
        this.mis.misDetails.training.requiredTraining.pgbPresenter -
        this.mis.misDetails.training.actualTraining.pgbPresenter;
    }
    if (
      this.mis.misDetails.training.requiredTraining.pgbInternal != null &&
      this.mis.misDetails.training.actualTraining.pgbInternal != null
    ) {
      this.mis.misDetails.training.balanceTraining.pgbInternal =
        this.mis.misDetails.training.requiredTraining.pgbInternal -
        this.mis.misDetails.training.actualTraining.pgbInternal;
    }
    if (
      this.mis.misDetails.training.requiredTraining.cpe != null &&
      this.mis.misDetails.training.actualTraining.cpe != null
    ) {
      this.mis.misDetails.training.balanceTraining.cpe =
        this.mis.misDetails.training.requiredTraining.cpe -
        this.mis.misDetails.training.actualTraining.cpe;
    }
  }

  calculateEndOfQuarter() {
   
    var totalToMinus=0;
    var feesRecievableIndex=0;
    var GSTreceivableIndex=0;

    for (const financial of this.mis.misDetails.financialsData) {
      if (
        financial.variable ==='Fees receivable opening balance (closing last quarter)'
      ) {
        var question1 = financial.amount;
      }
      if (financial.variable === 'Invoices raised during the quarter') {
        var question2 = financial.amount;
      }
      if (financial.variable === 'Fees received during the quarter') {
        var question3 = financial.amount;
      }
      if (financial.variable ==='GST receivable opening balance (closing last quarter)') 
      {
        var question5 = financial.amount;
      }
      if (financial.variable === 'GST on Invoices raised during the quarter') {
        var question6 = financial.amount;
      }
      if (financial.variable === 'GST received during the quarter') {
        var question7 = financial.amount;
      }
      if (financial.variable === 'Invoices written off') {
        var question13 = financial.amount;        
      }
      if (financial.variable === 'Credit notes issued') {
        var question14 = financial.amount;
      }
      
    }

    if (question3 !== undefined && question3 !== 0) {
      totalToMinus += question3;
    }
    if (question13 !== undefined && question13 !== 0) {
      totalToMinus += question13;
    }
    if (question14 !== undefined && question14 !== 0) {
      totalToMinus += question14;
    }

    feesRecievableIndex=this.mis.misDetails.financialsData.findIndex(financial => financial.variable === 'Fees receivable at the end of quarter');
    this.mis.misDetails.financialsData[feesRecievableIndex].amount = question1 + question2 - totalToMinus;

    GSTreceivableIndex=this.mis.misDetails.financialsData.findIndex(financial => financial.variable === 'GST receivable at the end of quarter');
    this.mis.misDetails.financialsData[GSTreceivableIndex].amount = question5 + question6 - question7;
    
  }

  

  saveMisForm() {
    if (this.selectedQuarter && this.fyId) {
      console.log('financials section:', this.checkList);
      console.log('mis interface', this.mis);

      for (let i = 0; i < this.mis.misDetails.business.newClient.length; i++) {
        for (
          let j = 0;
          j < this.mis.misDetails.business.newClient[i].assignments.length;
          j++
        ) {
          console.log('appointment date:');
          if (
            this.mis.misDetails.business.newClient[i].assignments[j]
              .appointmentDate != '' &&
            this.mis.misDetails.business.newClient[i].assignments[j]
              .appointmentDate != undefined &&
            this.mis.misDetails.business.newClient[i].assignments[j]
              .appointmentDate != null
          ) {
            this.mis.misDetails.business.newClient[i].assignments[
              j
            ].appointmentDate = this.formatDate(
              this.mis.misDetails.business.newClient[i].assignments[j]
                .appointmentDate
            );
          }

          if (
            this.mis.misDetails.business.newClient[i].clientCreationDate !=
              '' &&
            this.mis.misDetails.business.newClient[i].clientCreationDate !=
              undefined &&
            this.mis.misDetails.business.newClient[i].clientCreationDate != null
          ) {
            this.mis.misDetails.business.newClient[i].clientCreationDate =
              this.formatDate(
                this.mis.misDetails.business.newClient[i].clientCreationDate
              );
          }

          if (
            this.mis.misDetails.business.newClient[i].assignments[j]
              .dateOfNocSent != '' &&
            this.mis.misDetails.business.newClient[i].assignments[j]
              .dateOfNocSent != undefined &&
            this.mis.misDetails.business.newClient[i].assignments[j]
              .dateOfNocSent != null
          ) {
            this.mis.misDetails.business.newClient[i].assignments[
              j
            ].dateOfNocSent = this.formatDate(
              this.mis.misDetails.business.newClient[i].assignments[j]
                .dateOfNocSent
            );
          }

          if (
            this.mis.misDetails.business.newClient[i].assignments[j]
              .engagementLetterDate != '' &&
            this.mis.misDetails.business.newClient[i].assignments[j]
              .engagementLetterDate != undefined &&
            this.mis.misDetails.business.newClient[i].assignments[j]
              .engagementLetterDate != null
          ) {
            this.mis.misDetails.business.newClient[i].assignments[
              j
            ].engagementLetterDate = this.formatDate(
              this.mis.misDetails.business.newClient[i].assignments[j]
                .engagementLetterDate
            );
          }
        }
      }

      for (
        let i = 0;
        i < this.mis.misDetails.financialInterests.loan.length;
        i++
      ) {
        if (
          this.mis.misDetails.financialInterests.loan[i].maturityDate != '' &&
          this.mis.misDetails.financialInterests.loan[i].maturityDate !=
            undefined &&
          this.mis.misDetails.financialInterests.loan[i].maturityDate != null
        ) {
          console.log(
            'inside maturity',
            this.mis.misDetails.financialInterests.loan[i].maturityDate
          );
          this.mis.misDetails.financialInterests.loan[i].maturityDate =
            this.formatDate(
              this.mis.misDetails.financialInterests.loan[i].maturityDate
            );
        }
      }

      console.log('isUpdate', this.isUpdate);
      if (this.isUpdate) {
        console.log('mis for update changes', this.mis);
        console.log('fyId', this.fyId);
        console.log('quarter', this.mis.quarter);
        this.mis.fyId = this.fyId;
        this.mis.quarter = this.selectedQuarter;
        this.organizationSetupService
          .updateMisDetails(this.mis)
          .subscribe((resp: any) => {
            console.log('mis update response:', resp);
            this.misUploadDocument(resp);

            this.commonMessageService.swalAlertWithIcon(
              '',
              'Updated Successfully!',
              'success'
            );
            //  if(resp)
            //  { this.deleteFile(0);
            //   this.getMisDetails();
            // }
            this.getMisDetails();
          });
        console.log('Update');
      } else {
        console.log('mis for save', this.mis);
        console.log('fyId', this.fyId);
        console.log('quarter', this.mis.quarter);
        this.organizationSetupService
          .saveMisDetails(this.mis)
          .subscribe((resp: any) => {
            console.log('mis save response:', resp);
            this.misUploadDocument(resp);
            this.commonMessageService.swalAlertWithIcon(
              '',
              'Saved Successfully!',
              'success'
            );
             this.getMisDetails();
          });
        console.log('Save');
      }
    } else {
      this.commonMessageService.swalAlertWithIcon(
        '',
        'Select Financial Year & Quarter!',
        'info'
      );
    }
  }

  checkNewClientSection() {
    for (let i = 0; i < this.mis.misDetails.business.newClient.length; i++) {
      for (let j = 0; j < this.mis.misDetails.business.newClient.length; j++) {
        if (
          !this.mis.misDetails.business.newClient[i].assignments[j]
            .appointmentDate ||
          !this.mis.misDetails.business.newClient[i].clientId ||
          !this.mis.misDetails.business.newClient[i].assignments[j]
            .assignmentId ||
          !this.mis.misDetails.business.newClient[i].assignments[j].frequency ||
          !this.mis.misDetails.business.newClient[i].assignments[j].fees ||
          !this.mis.misDetails.business.newClient[i].assignments[j]
            .budgetedContributionPercentage ||
          !this.mis.misDetails.business.newClient[i].assignments[j]
            .incentiveTo ||
          !this.mis.misDetails.business.newClient[i].branch ||
          !this.mis.misDetails.business.newClient[i].clientCreationDate ||
          !this.mis.misDetails.business.newClient[i].assignments[j]
            .dateOfNocSent ||
          !this.mis.misDetails.business.newClient[i].assignments[j]
            .engagementLetterDate
        ) {
          console.log('newClient data');
          return false;
        } else {
          return true;
        }
      }
    }
  }

  checkNewAssignExistingClient() {
    for (
      let i = 0;
      i < this.mis.misDetails.business.newAssignmentForExistingClient.length;
      i++
    ) {
      if (
        !this.mis.misDetails.business.newAssignmentForExistingClient[i]
          .clientId ||
        !this.mis.misDetails.business.newAssignmentForExistingClient[i]
          .assignmentId ||
        !this.mis.misDetails.business.newAssignmentForExistingClient[i]
          .frequency ||
        !this.mis.misDetails.business.newAssignmentForExistingClient[i].fees ||
        !this.mis.misDetails.business.newAssignmentForExistingClient[i]
          .budgetedContributionPercentage
      ) {
        // || !this.mis.misDetails.business.newAssignmentForExistingClient[i].incentive
        // || !this.mis.misDetails.business.newAssignmentForExistingClient[i].branch)
        console.log('newAssignmentForExistingClient data');
        return false;
      } else {
        return true;
      }
    }
  }

  checkClientAssignDiscontinued() {
    for (
      let i = 0;
      i < this.mis.misDetails.business.clientsOrAssignmentDiscontinued.length;
      i++
    ) {
      if (
        !this.mis.misDetails.business.clientsOrAssignmentDiscontinued[i]
          .clientId ||
        !this.mis.misDetails.business.clientsOrAssignmentDiscontinued[i]
          .assignmentId ||
        !this.mis.misDetails.business.clientsOrAssignmentDiscontinued[i].fees ||
        !this.mis.misDetails.business.clientsOrAssignmentDiscontinued[i].reason
      ) {
        console.log('clientsOrAssignmentDiscontinued data');
        return false;
      } else {
        return true;
      }
    }
  }

  checkFeesIncreasedDecreased() {
    for (
      let i = 0;
      i < this.mis.misDetails.business.feesIncreasedOrDecreased.length;
      i++
    ) {
      if (
        !this.mis.misDetails.business.feesIncreasedOrDecreased[i].clientId ||
        !this.mis.misDetails.business.feesIncreasedOrDecreased[i]
          .assignmentId ||
        !this.mis.misDetails.business.feesIncreasedOrDecreased[i].oldFees ||
        !this.mis.misDetails.business.feesIncreasedOrDecreased[i].newFees ||
        !this.mis.misDetails.business.feesIncreasedOrDecreased[i].remark
      ) {
        console.log('feesIncreasedOrDecreased data');
        return false;
      } else {
        return true;
      }
    }
  }

  checkPotentialClientAssign() {
    for (
      let i = 0;
      i < this.mis.misDetails.business.potentialClientOrAssignment.length;
      i++
    ) {
      if (
        !this.mis.misDetails.business.potentialClientOrAssignment[i]
          .clientName ||
        !this.mis.misDetails.business.potentialClientOrAssignment[i]
          .assignmentId ||
        !this.mis.misDetails.business.potentialClientOrAssignment[i]
          .frequency ||
        !this.mis.misDetails.business.potentialClientOrAssignment[i].fees ||
        !this.mis.misDetails.business.potentialClientOrAssignment[i].connectName
      ) {
        console.log('potentialClientOrAssignment data');
        return false;
      } else {
        return true;
      }
    }
  }

  checkMaterialIssues() {
    for (let i = 0; i < this.mis.misDetails.materialIssues.length; i++) {
      if (
        !this.mis.misDetails.materialIssues[i].client ||
        !this.mis.misDetails.materialIssues[i].description
      ) {
        console.log('materialIssues data');
        return false;
      } else {
        return true;
      }
    }
  }

  checkFormFields() {
    console.log('mis check:', this.mis);
    let flag = true;
    //financial year and quarter check
    if (!this.fyId || !this.selectedQuarter) {
      flag = false;
      console.log('financial year and quarter data');
    }
    //financial data section
    for (let i = 0; i < this.mis.misDetails.financialsData.length; i++) {
      if (this.mis.misDetails.financialsData[i].amount == null) {
        flag = false;
        console.log('fianancials data');
        break;
      }
    }
    //business section

    if (this.newClientSelectValue == 'yes') {
      for (let i = 0; i < this.mis.misDetails.business.newClient.length; i++) {
        for (
          let j = 0;
          j < this.mis.misDetails.business.newClient[i].assignments.length;
          j++
        ) {
          if (
            !this.mis.misDetails.business.newClient[i].assignments[j]
              .appointmentDate ||
            !this.mis.misDetails.business.newClient[i].clientId ||
            !this.mis.misDetails.business.newClient[i].assignments[j]
              .assignmentId ||
            !this.mis.misDetails.business.newClient[i].assignments[j]
              .frequency ||
            !this.mis.misDetails.business.newClient[i].assignments[j].fees ||
            !this.mis.misDetails.business.newClient[i].assignments[j]
              .budgetedContributionPercentage ||
            !this.mis.misDetails.business.newClient[i].assignments[j]
              .incentiveTo ||
            !this.mis.misDetails.business.newClient[i].branch ||
            !this.mis.misDetails.business.newClient[i].clientCreationDate ||
            !this.mis.misDetails.business.newClient[i].assignments[j]
              .dateOfNocSent ||
            !this.mis.misDetails.business.newClient[i].assignments[j]
              .engagementLetterDate
          ) {
            flag = false;
            console.log('newClient data');
            break;
          }else{

              if(!this.mis.misDetails.business.newClient[i].assignments[j].engagementLetterDate.year && this.mis.misDetails.business.newClient[i].assignments[j].engagementLetterDate.ELrequired=='yes')
              {
                  console.log("engagement letter date null");
                  flag = false;
              }
              else if(!this.mis.misDetails.business.newClient[i].assignments[j].dateOfNocSent.year && this.mis.misDetails.business.newClient[i].assignments[j].dateOfNocSent.NOCrequired=='yes')
              {
                console.log("dateOfNocSent null");
                flag = false;
              }
              else if(!this.mis.misDetails.business.newClient[i].assignments[j].appointmentDate.year)
              {
                console.log("appointmentDate null");
                flag = false;
              }
          }

        }
      }
    }

    if (this.newAssignExistingClient == 'yes') {
      for (
        let i = 0;
        i < this.mis.misDetails.business.newAssignmentForExistingClient.length;
        i++
      ) {
        if (
          !this.mis.misDetails.business.newAssignmentForExistingClient[i]
            .clientId ||
          !this.mis.misDetails.business.newAssignmentForExistingClient[i]
            .assignmentId ||
          !this.mis.misDetails.business.newAssignmentForExistingClient[i]
            .frequency ||
          !this.mis.misDetails.business.newAssignmentForExistingClient[i]
            .fees ||
          !this.mis.misDetails.business.newAssignmentForExistingClient[i]
            .budgetedContributionPercentage
        ) {
          flag = false;
          console.log('newAssignmentForExistingClient data');
          break;
        }
      }
    }

    if (this.clientAssignDiscontinued == 'yes') {
      for (
        let i = 0;
        i < this.mis.misDetails.business.clientsOrAssignmentDiscontinued.length;
        i++
      ) {
        if (
          !this.mis.misDetails.business.clientsOrAssignmentDiscontinued[i]
            .clientId ||
          !this.mis.misDetails.business.clientsOrAssignmentDiscontinued[i]
            .assignmentId ||
          !this.mis.misDetails.business.clientsOrAssignmentDiscontinued[i]
            .fees ||
          !this.mis.misDetails.business.clientsOrAssignmentDiscontinued[i]
            .reason
        ) {
          flag = false;
          console.log('clientsOrAssignmentDiscontinued data');
          break;
        }
      }
    }

    //   for (let i = 0; i < this.mis.misDetails.business.clientsOrAssignmentDiscontinued.length; i++) {
    //     if(!this.mis.misDetails.business.clientsOrAssignmentDiscontinued[i].clientId
    //       || !this.mis.misDetails.business.clientsOrAssignmentDiscontinued[i].assignmentId
    //       || !this.mis.misDetails.business.clientsOrAssignmentDiscontinued[i].fees
    //       || !this.mis.misDetails.business.clientsOrAssignmentDiscontinued[i].reason)
    //     {
    //       flag = false;
    //       console.log("clientsOrAssignmentDiscontinued data");
    //       break;
    //     }

    // }
    if (this.feesIncreasedDecreased == 'yes') {
      for (
        let i = 0;
        i < this.mis.misDetails.business.feesIncreasedOrDecreased.length;
        i++
      ) {
        if (
          !this.mis.misDetails.business.feesIncreasedOrDecreased[i].clientId ||
          !this.mis.misDetails.business.feesIncreasedOrDecreased[i]
            .assignmentId ||
          !this.mis.misDetails.business.feesIncreasedOrDecreased[i].oldFees ||
          !this.mis.misDetails.business.feesIncreasedOrDecreased[i].newFees ||
          !this.mis.misDetails.business.feesIncreasedOrDecreased[i].remark
        ) {
          flag = false;
          console.log('feesIncreasedOrDecreased data');
          break;
        }
      }
    }

    if (this.potentialClientAssign == 'yes') {
      for (
        let i = 0;
        i < this.mis.misDetails.business.potentialClientOrAssignment.length;
        i++
      ) {
        if (
          !this.mis.misDetails.business.potentialClientOrAssignment[i]
            .clientName ||
          !this.mis.misDetails.business.potentialClientOrAssignment[i]
            .assignmentId ||
          !this.mis.misDetails.business.potentialClientOrAssignment[i]
            .frequency ||
          !this.mis.misDetails.business.potentialClientOrAssignment[i].fees ||
          !this.mis.misDetails.business.potentialClientOrAssignment[i]
            .connectName
        ) {
          flag = false;
          console.log('potentialClientOrAssignment data');
          break;
        }
      }
    }

    //engagement Performance section
    for (let i = 0; i < this.mis.misDetails.engagementPerformance.length; i++) {

      if(this.mis.misDetails.engagementPerformance[i].answer=="")
      {
          flag = false;
          console.log('engagementPerformance answer empty');
          break;
      }
      else if (this.mis.misDetails.engagementPerformance[i].required && (!this.mis.misDetails.engagementPerformance[i].answer ||
          !this.mis.misDetails.engagementPerformance[i].remark)
      ) {

       
            flag = false;
            console.log('engagementPerformance data');
            break;
        
      }
    }

    //financial Interests
    for (
      let i = 0;
      i < this.mis.misDetails.financialInterests.loan.length;
      i++
    ) {
      if (
        !this.mis.misDetails.financialInterests.loan[i].bank ||
        !this.mis.misDetails.financialInterests.loan[i].loanPurpose ||
        !this.mis.misDetails.financialInterests.loan[i].loanAmount==null ) {
          flag = false;
          console.log('financialInterests-loan data');
          break;

      }
      // else if(!this.mis.misDetails.financialInterests.loan[i].maturityDate.year)
      // {
      //           console.log("maturityDate null");
      //           flag = false;
      // }
    }

    for (
      let i = 0;
      i < this.mis.misDetails.financialInterests.privateInvestment.length;
      i++
    ) {
      if (
        !this.mis.misDetails.financialInterests.privateInvestment[i]
          .companyName ||
        !this.mis.misDetails.financialInterests.privateInvestment[i].amount==null||
        !this.mis.misDetails.financialInterests.privateInvestment[i]
          .sharesCount==null ||
        !this.mis.misDetails.financialInterests.privateInvestment[i]
          .investmentNature
      ) {
        flag = false;
        console.log('financialInterests-privateInvestment data');
        break;
      }
    }

    if (!this.mis.misDetails.financialInterests.documents || this.mis.misDetails.financialInterests.documents.length==0) {
      flag = false;
      console.log('financialInterests-documents data');
    }

    //material issues
    if (this.materialIssuesSection == 'yes') {
      for (let i = 0; i < this.mis.misDetails.materialIssues.length; i++) {
        if (
          !this.mis.misDetails.materialIssues[i].client ||
          !this.mis.misDetails.materialIssues[i].description
        ) {
          flag = false;
          console.log('materialIssues data');
          break;
        }
      }
    }

    //independence section
    for (let i = 0; i < this.mis.misDetails.independence.length; i++) {
      
      
      if(this.mis.misDetails.independence[i].answer=="")
      {
          flag = false;
          console.log('independence answer empty');
          break;
      }
      else if (
        this.mis.misDetails.independence[i].required &&
        (!this.mis.misDetails.independence[i].answer ||
          !this.mis.misDetails.independence[i].remark)
      ) {
        flag = false;
        console.log('independence data');
        break;
      }
    }

    //training section
    if (
      this.mis.misDetails.training.actualTraining.cpe == null ||
      this.mis.misDetails.training.actualTraining.pgbInternal == null ||
      this.mis.misDetails.training.actualTraining.pgbPresenter == null
    ) {
      flag = false;
      console.log('training-actualTraining data');
    }

    if (
      this.mis.misDetails.training.balanceTraining.cpe == null ||
      this.mis.misDetails.training.balanceTraining.pgbInternal == null ||
      !this.mis.misDetails.training.balanceTraining.pgbPresenter == null
    ) {
      flag = false;
      console.log('training-balanceTraining data');
    }

    return flag;
  }

  detectRequiredValidation(clist: any) {
    console.log('checking required field', clist);
    if (clist.answer == clist.expectedValue && !clist.remark) {
      clist.required = true;
      console.log(' required true');
    } else {
      clist.required = false;
      console.log(' required false');
    }
  }

  detectRequiredValidationOfList(misList: any[]) {
    for (const clist of misList) {
      console.log('checking required field', clist);
      if (clist.answer != '') {
        if (clist.answer == clist.expectedValue && !clist.remark) {
          clist.required = true;
          console.log(' required true');
        } else {
          clist.required = false;
          console.log(' required false');
        }
      }
    }
  }

  submitMisDetails() {
    if (this.selectedQuarter && this.fyId) {
      if (this.checkFormFields()) {
        console.log('all fields are filled');
        this.organizationSetupService.submitMisDetails(this.mis, this.mis.id)
          .subscribe((resp: any) => {
            console.log('mis submit response:', resp);
            this.commonMessageService.swalAlertWithIcon('', 'Submitted Successfully!', 'success');
            this.getMisDetails();
          });
      } else {
        console.log('all fields are not filled');
        this.commonMessageService.swalAlertWithIcon('', 'Fill all mandatory fields!', 'info');
      }
    } else {
      this.commonMessageService.swalAlertWithIcon('', 'Select Financial Year & Quarter!', 'info');
    }
  }
  
  misUploadDocument(resp: any) {
    console.log('finalSelectedFiles', this.finalSelectedFiles);
    if (this.finalSelectedFiles.length > 0) {
      this.formData = new FormData();
      for (var i = 0; i < this.finalSelectedFiles.length; i++) {
        let file: File = this.finalSelectedFiles[i];
        this.formData.append('files', file, file.name);
      }

      this.organizationSetupService
        .uploadMisDocuments(this.formData, resp.id)
        .subscribe((res) => {
          console.log('uploaded docs:', res);
          if (res) {
            this.deleteFile(0);
            this.getMisDetails();
          }

          // this.commonMessageService.swalAlertWithIcon('','Saved Successfully!','success');
        });
    }
  }

  //upload file

  async uploadFiles() {
    console.log('this.files', this.files);
    console.log('this.files', this.finalSelectedFiles);
    this.message = '';

    for (let i = 0; i < this.finalSelectedFiles.length; i++) {
      console.log('File Upload Data', this.finalSelectedFiles[i]);
      //this.upload(this.finalSelectedFiles[i],this.files[i])
    }
  }

  message = '';

  progressInfos;
  selectedFiles: FileList;
  finalSelectedFiles = [];
  onFileSelected(e, status) {
    var filelist = [];
    console.log('e', e);

    if (status == 'onDrop') {
      console.log('e', e);
      filelist = e;
      this.selectedFiles = e;
      for (let i = 0; i < this.selectedFiles.length; i++) {
        this.finalSelectedFiles.push(this.selectedFiles[i]);
      }
    } else {
      console.log('e', e.target.files);
      this.progressInfos = [];
      filelist = e.target.files;
      this.selectedFiles = e.target.files;
      for (let i = 0; i < this.selectedFiles.length; i++) {
        this.finalSelectedFiles.push(this.selectedFiles[i]);
      }
    }

    //pick from one of the 4 styles of file uploads below
    //this.files = [];
    console.log('Event Files', filelist);
    var file_size;

    for (const file of filelist) {
      // calculate File Size
      var _size = file.size;
      var fSExt = new Array('Bytes', 'KB', 'MB', 'GB'),
        i = 0;
      while (_size > 900) {
        _size /= 1024;
        i++;
      }
      file_size = Math.round(_size * 100) / 100 + ' ' + fSExt[i];
      console.log('FILE SIZE = ', file_size);
      // create composed object with different information. ADAPT THIS ACCORDING YOUR NEED
      const files = {
        fileName: file.name,
        fileType: file.type,
        fileSize: file_size,
        description: 'Enter Notes Here',
        isPrivate: false,
        displayFileName: file.name,
      };

      // push each upload into the array
      this.files.push(files);
    }

    console.log('Files Selected', this.files);
  }

  /**
   * on file drop handler
   */
  onFileDropped($event) {
    this.onFileSelected($event, 'onDrop'); //this.prepareFilesList($event);
  }

  /**
   * handle file from browsing
   */
  fileBrowseHandler(files) {
    this.prepareFilesList(files);
  }

  /**
   * Delete file from files list
   * @param index (File index)
   */
  async deleteFile(index: number) {
    console.log('this.files', this.files);
    console.log('this.files', this.finalSelectedFiles);
    console.log('this.files index', this.files[index]);
    console.log(
      'this.finalSelectedFiles index',
      this.finalSelectedFiles[index]
    );
    this.files.splice(index, 1);
    this.finalSelectedFiles.splice(index, 1);
    // var file = this.files[index]
    // var finalSelectedFilesIndex : any
    // await this.finalSelectedFiles.map((resp,index) =>{
    //   if(isEqual(resp, file)){
    //     finalSelectedFilesIndex = index
    //   }
    // })
    // this.finalSelectedFiles.splice(finalSelectedFilesIndex,1)
    // this.files.splice(index,1)
  }

  /**
   * Simulate the upload process
   */
  uploadFilesSimulator(index: number) {
    // setTimeout(() => {
    //   if (index === this.files.length) {
    //     return;
    //   } else {
    //     const progressInterval = setInterval(() => {
    //       if(this.files[index].progress != undefined){
    //         if (this.files[index].progress === 100) {
    //           clearInterval(progressInterval);
    //           this.uploadFilesSimulator(index + 1);
    //         } else {
    //           this.files[index].progress += 5;
    //         }
    //       }
    //     }, 200);
    //   }
    // }, 1000);
  }

  /**
   * Convert Files list to normal array list
   * @param files (Files List)
   */
  prepareFilesList(files: Array<any>) {
    for (const item of files) {
      item.progress = 0;
      this.files.push(item);
    }
    this.uploadFilesSimulator(0);
  }

  /**
   * format bytes
   * @param bytes (File size in bytes)
   * @param decimals (Decimals point)
   */
  formatBytes(bytes, decimals) {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  saveFiles() {
    console.log('saveFiles', this.files);
  }

  changeEngagementLetterDate(index1,index2){
    if(this.mis.misDetails.business.newClient[index1].assignments[index2].ELrequired === 'no')
    {
      this.mis.misDetails.business.newClient[index1].assignments[index2].engagementLetterDate={ year: null, month: null, day: null };
    }
    console.log("EL date changed",this.mis.misDetails.business.newClient[index1].assignments[index2].engagementLetterDate)
  }

  changeNocDate(index1,index2){
    if(this.mis.misDetails.business.newClient[index1].assignments[index2].NOCrequired === 'no')
    {
      this.mis.misDetails.business.newClient[index1].assignments[index2].dateOfNocSent={ year: null, month: null, day: null };
    }
    console.log("NOC date changed",this.mis.misDetails.business.newClient[index1].assignments[index2].dateOfNocSent)

  }
}